import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  typePageTitle: {
    id: 'notfound.typePageTitle',
    description: 'Title for the "Not Found" view',
    defaultMessage: 'Sivua ei löytynyt.',
  },
  typePageTroubleshoot: {
    id: 'notfound.typePageTroubleshoot',
    description: 'General ideas to troubleshoot the error',
    defaultMessage: 'Tarkista, kirjoititko osoitteen oikein.',
  },
  typeCompanyTitle: {
    id: 'notfound.typeCompanyTitle',
    description: 'Title for the "Not Found" view',
    defaultMessage: 'Sivua ei löytynyt.',
  },
  typeCompanyDescription: {
    id: 'notfound.typeCompanyDescription',
    description: 'Description text explaining why the company was not found',
    defaultMessage: 'Uudistamme Vastuu Groupin hakupalveluita.',
  },
  typeCompanyTroubleshoot: {
    id: 'notfound.typeCompanyTroubleshoot',
    description: 'General ideas to troubleshoot the error',
    defaultMessage: 'Tarkista, kirjoititko osoitteen oikein.',
  },
});
